<template>
  <div>
    <b-container>
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(next)" autocomplete="off">
          <b-card>
            <template #header>
              <h6 class="mb-0">Continuidad de póliza</h6>
            </template>

            <p class="text-muted small mb-3">
              ¿Ha estado alguna vez asegurado en alguna póliza colectiva de vida o salud?
            </p>

            <b-form-group>
              <RadioComponent :form="form" name="continuidadPoliza" :options="control.TIPOS_SINO" rules="required" />
            </b-form-group>

            <template v-if="form.continuidadPoliza === 'S'">
              <b-row class="mb-3">
                <b-col md="8" cols="12" class="mb-2 mb-md-0">
                  <TextComponent
                    :form="form"
                    name="nombreTomadorPoliza"
                    label="Nombre del tomador de la pólizao"
                    rules="required"
                  />
                </b-col>

                <b-col md="4" cols="12">
                  <DateComponent
                    :form="form"
                    name="fechaSeguro"
                    label="Y fecha del seguro (mm/dd/aaaa)"
                    rules="required"
                  />
                </b-col>
              </b-row>

              <div class="continuidad-texto mt-3 mb-3 p-3 bg-light rounded">
                <p class="small mb-2">
                  Previa evaluación de la aseguradora, se otorga continuidad de amparo de otras pólizas de salud o
                  contratos de medicina prepagada, siempre y cuando las coberturas sean equivalentes a las ofrecidas en
                  este seguro, para lo cual se requiere certificación de la anterior aseguradora con respecto a
                  coberturas, preexistencias, antigüedad y utilizaciones.
                </p>
                <p class="small font-weight-bold mb-0 text-uppercase">
                  Si solicita continuidad de otra póliza de salud o contrato de medicina prepagada por favor indique:
                </p>
              </div>

              <p class="small font-weight-bold mt-3">Detalle por solicitante</p>
              <div class="table-responsive">
                <table class="table-one">
                  <thead>
                    <tr>
                      <th>Nombre del Solicitante</th>
                      <th>Compañía</th>
                      <th>Plan</th>
                      <th>Fecha de Inicio</th>
                      <th>Nº de Póliza o Contrato</th>
                      <th>Fecha Vencimiento</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in form.continuidadDetalle" :key="index">
                      <td style="display: none">
                        <span>Fila {{ index + 1 }}</span>
                      </td>
                      <td>
                        <b-form-input v-model="item.nombreSolicitante" disabled />
                      </td>
                      <td><b-form-input v-model="item.compania" /></td>
                      <td><b-form-input v-model="item.plan" /></td>
                      <DateGrid :form="form" name="fechaInicio" label="Fecha de Inicio" rules="required"/>
                      
                      <td><b-form-input v-model="item.numPolizaContrato" type="text" /></td>
                      
                      <DateGrid
                        :form="item"
                        name="fechaVencimiento"
                        label="Fecha de Vencimiento"
                        rules="required"
                      />
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>

            <b-row align-h="end" class="mt-4">
              <b-col md="4" cols="4" style="display: flex; justify-content: flex-end">
                <b-button @click="previous" variant="secondary">Anterior</b-button>
                <b-button type="submit" variant="primary">Siguiente</b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-form>
      </validation-observer>
    </b-container>
  </div>
</template>

<script>
import DateComponent from "@/components/controls/DateComponent.vue";
import DateGrid from "@/components/controls/DateGrid.vue";
import RadioComponent from "@/components/controls/RadioComponent.vue";
import TextComponent from "@/components/controls/TextComponent.vue";
import { TIPOS_SINO } from "@/data/colombia/salud/Selects";

function personaTieneDatos(p) {
  if (!p) return false;
  return !!(
    (p.name && String(p.name).trim()) ||
    (p.document && String(p.document).trim()) ||
    p.birthDay ||
    p.relation ||
    (p.weight !== undefined && p.weight !== null && p.weight !== "") ||
    (p.stature !== undefined && p.stature !== null && p.stature !== "") ||
    p.sex ||
    (p.eps && String(p.eps).trim())
  );
}

export default {
  name: "FormColombiaSalud05",
  components: { RadioComponent, TextComponent, DateComponent, DateGrid },
  data() {
    return {
      control: { TIPOS_SINO },
      form: {},
    };
  },
  mounted() {
    this.$store.dispatch("app/loading", true);
    const { form } = this.$store.state.wizard;
    if (form === undefined || form === null || form === "") {
      this.$router.push("/form/colombia/salud/");
      return;
    }
    this.form = form;
    if (this.form.nombreTomadorPoliza === undefined) this.form.nombreTomadorPoliza = "";
    if (this.form.fechaSeguro === undefined) this.form.fechaSeguro = "";
    const personasConDatos = (this.form.beneficiarios || []).filter(personaTieneDatos);
    const existing =
      this.form.continuidadDetalle && Array.isArray(this.form.continuidadDetalle) ? this.form.continuidadDetalle : [];

    this.form.continuidadDetalle = personasConDatos.map((persona, i) => ({
      nombreSolicitante: (persona.name || "").trim() || "",
      compania: (existing[i] && existing[i].compania) || "",
      plan: (existing[i] && existing[i].plan) || "",
      fechaInicio: (existing[i] && existing[i].fechaInicio) || "",
      numPolizaContrato: (existing[i] && existing[i].numPolizaContrato) || "",
      fechaVencimiento: (existing[i] && existing[i].fechaVencimiento) || "",
    }));
    this.$store.dispatch("app/loading", false);
  },
  methods: {
    previous() {
      this.$store
        .dispatch("wizard/save", { index: 4, form: this.form })
        .then(() => this.$router.push("/form/colombia-salud-4.html"));
    },
    next() {
      if (this.form.continuidadPoliza === "S") {
        const vacios = (this.form.continuidadDetalle || []).every(
          (r) => !(r.nombreSolicitante || "").trim() && !(r.compania || "").trim() && !(r.plan || "").trim()
        );
        if (vacios) {
          this.$bvToast.toast("Si indicó continuidad, complete al menos una fila de detalle.", {
            title: "Validación",
            variant: "warning",
            solid: true,
          });
          return;
        }
      }
      this.$store
        .dispatch("wizard/save", { index: 5, form: this.form })
        .then(() => this.$router.push("/form/colombia-salud-6.html"));
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 1600px;
}
</style>
